import * as React from "react";
import {authorize, IWithRouterProps, Overlay, withRouter} from "@athena-portal/components";
import {PluginTemplates} from "../../../../../utils/PluginTemplates";
import FalconFooter from "../../../../../components/navigation/FalconFooter";
import FalconHeader from "../../../../../components/navigation/FalconHeader";
import {
    deleteSessionStorage,
    getSessionStorage,
    scrollToTop
} from "../../../../../CommonFunctions";
import {OnlineMotorClaimRequest} from "@falcon/services";
import {BackButton} from "../../../../../components/navigation/BackButton";
import {ClaimSubmissionPanel} from "../../../../../components/claims/ClaimSubmissionPanel";
import {AllianzOnlineBadge} from "../../../../../components/AllianzOnlineBadge";

interface IClaimSubmittedPageState {
    onlineMotorClaimRequest: OnlineMotorClaimRequest;
    showOverlay: boolean | null;
}

@authorize
export class AnnualMotorClaimSubmittedPagePlain extends React.Component<IWithRouterProps, IClaimSubmittedPageState> {

    private pluginTemplates = new PluginTemplates();

    constructor(props: IWithRouterProps) {
        super(props);
        const onlineMotorClaimRequest: OnlineMotorClaimRequest = getSessionStorage("onlineMotorClaimRequest");

        this.state = {
            onlineMotorClaimRequest: onlineMotorClaimRequest !== null ? onlineMotorClaimRequest : new OnlineMotorClaimRequest(),
            showOverlay: (this.props.location.state && this.props.location.state.showOverlay) ? this.props.location.state.showOverlay : false
        }
    }

    public componentDidMount(): void {
        scrollToTop();
        this.pluginTemplates.setPageTitle("Make a car claim");
        window.addEventListener("beforeunload", this.clearSession);
        this.setState({showOverlay: false});
    }

    public componentWillUnmount() {
        window.removeEventListener("beforeunload", this.clearSession);
        this.clearSession();
    }

    public render() {
        if (!this.state.showOverlay) {
            return (
                <React.Fragment>
                    <FalconHeader/>

                    <div className="page-contents text-center">
                        <AllianzOnlineBadge/>
                        <BackButton isTop={true} link={"/dashboard/"} />
                        <ClaimSubmissionPanel onlineClaimRequest={this.state.onlineMotorClaimRequest} showUrgentClaimSection={true} />
                        <BackButton isTop={false} link={"/dashboard/"} />
                    </div>

                    <FalconFooter/>
                </React.Fragment>
            );
        } else {
            return (<Overlay show={true}/>)
        }
    }

    private clearSession = (): void => {
        deleteSessionStorage("onlineMotorClaimRequest");
    };
}

export const AnnualMotorClaimSubmittedPage = withRouter(AnnualMotorClaimSubmittedPagePlain)
